/* eslint-disable no-bitwise */
function parseAccess(access) {
  const state = (access & 0b001) !== 0;
  const set = (access & 0b010) !== 0;
  const get = (access & 0b100) !== 0;

  // Rule: get can only be active if state is also active
  return {
    state,
    set,
    get: get && state,
  };
}

// prefere use hasState, because get is only allowed if state is also allowed
function hasGet(access) {
  const { get } = parseAccess(access);
  return get;
}

function hasSet(access) {
  const { set } = parseAccess(access);
  return set;
}

function hasState(access) {
  const { state } = parseAccess(access);
  return state;
}

export const Zigbee2MQTTUtils = {
  parseAccess,
  hasGet,
  hasSet,
  hasState,
};
